<template>
    <div>
        <div :style="{ width: isCollapse ? '66px' : '200px' }" style="background: #545c64; color: #fff; display: flex; flex-direction: column">
            <div style="padding: 10px; display: flex">
                <img style="overflow: hidden; display: block; border-radius: 22px; border: 1px solid gray" :src="require('@/assets/logo.png')" width="44px" height="44px" />
                <div v-if="!isCollapse" style="flex: 1; line-height: 44px; font-size: 26px; padding-left: 10px; white-space: nowrap; overflow: hidden">{{ (当前商户 || {}).C_商户名称 || 软件名称 }}</div>
            </div>
            <div>
                <el-select class="dark" v-model="当前门店" value-key="I_门店Id" filterable @change="onMDChange">
                    <el-option v-for="(item, index) in 有权限门店list" :key="index" :label="item.C_门店名称" :value="item">
                        <el-tag style="margin-right: 10px" :key="item.C_门店类型" size="small" v-if="item.C_门店类型 && item.C_门店类型 == '门店'">
                            {{ item.C_门店类型 }}
                        </el-tag>
                        <el-tag style="margin-right: 10px" :key="item.C_门店类型" size="small" type="danger" v-if="item.C_门店类型 && item.C_门店类型 == '配送中心'">
                            {{ item.C_门店类型 }}
                        </el-tag>
                        <span>({{ item.I_门店Id }}){{ item.C_门店名称 }}</span>
                    </el-option>
                </el-select>
            </div>
            <div style="flex: 1" class="hoverscrollbar">
                <el-menu style="border-right-color: rgb(84, 92, 100)" unique-opened router :default-active="$route.path" :collapse="isCollapse" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
                    <template v-for="(row, index) in menuList">
                        <template v-if="!row.visual || row.visual()">
                            <el-menu-item :index="row.to" :key="index" v-if="!row.children">
                                <i :class="row.icon"></i>
                                <span slot="title">{{ row.name }}</span>
                            </el-menu-item>
                            <el-submenu :index="index.toString()" :key="index" v-else>
                                <template slot="title">
                                    <i :class="row.icon"></i> <span slot="title">{{ row.name }}</span>
                                </template>
                                <el-menu-item-group>
                                    <template v-for="(row2, index2) in row.children">
                                        <template v-if="!row2.visual || row2.visual()">
                                            <el-menu-item :index="row2.to" :key="index2" :class="row2.class || ''">
                                                {{ row2.name }}
                                                <!-- <el-popover popper-class="darkpoper" placement="right" width="200" trigger="hover">
                                                    <div slot="reference">{{row2.name}}</div>
                                                    <template>
                                                        <div class="popermunu">
                                                            <el-menu mode="horizontal" router style="border-right-color: rgb(84, 92, 100);width:100%" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
                                                                <el-menu-item :index="row2.to" style="width:100%;" v-for="(row3,index3) in row2.children" :key="index+'-'+index2+index3">{{row3.name}}</el-menu-item>
                                                            </el-menu>
                                                        </div>
                                                    </template>
                                                </el-popover> -->
                                            </el-menu-item>
                                        </template>
                                    </template>
                                </el-menu-item-group>
                            </el-submenu>
                        </template>
                    </template>
                </el-menu>
            </div>
            <div style="padding: 5px; text-align: center; color: gray" :style="{ width: isCollapse ? '55px' : '200px' }">Ver {{ 版本号 }}</div>
        </div>
        <div style="flex: 1; overflow: hidden; display: flex">
            <router-tab restore page-transition="page-fade" style="flex: 1; overflow: hidden; display: flex" :tabs="['/main/index']">
                <template slot="start">
                    <el-button @click="isCollapse = !isCollapse" :icon="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" style="background: whitesmoke; border-radius: 0; border: none; height: 38px"></el-button>
                </template>
                <div slot="end" style="padding: 0 10px; display: flex">
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link" style="line-height: 40px"> {{ (当前员工 || {}).C_员工名称 || (当前员工 || {}).C_姓名 || "当前员工" }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="shortcut">发送到桌面快捷方式</el-dropdown-item>
                            <el-dropdown-item command="favorite">添加到收藏夹</el-dropdown-item>
                            <el-dropdown-item command="refresh" divided>强制刷新页面</el-dropdown-item>
                            <el-dropdown-item command="logout" divided>退出登录</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- <a style="padding:0 10px;line-height: 40px;" class="hand" target="_black" href="https://www.kancloud.cn/shengxq/peisong/2376587">
                        <i class="el-icon-question"></i>
                    </a> -->
                </div>
            </router-tab>
        </div>

        <elModal ref="excell导入选择列名对话框" class="dialog-90">
            <div style="padding: 10px; color: red">
                导入数据前，请为需要的列指定列名！不指定列名的数据不会导入!<br />
                【*】表示该列的值不能为空！<br />
                【默认值】值为空时指定默认值！<br />
                【必选】必须指定该列！<br />
                【唯一】该列的值不能重复！<br />
                【可自动获取】不指定该列时可以自动获取！<br />
            </div>
            <u-table :data="excell导入.data" height="300" @cell-click="onCellClick">
                <u-table-column type="index" :index="(index) => index + 1" label="#"></u-table-column>
                <u-table-column align="center" show-overflow-tooltip min-width="200" :prop="item" :label="item" v-for="(item, index) in excell导入.导入列名list" :key="index">
                    <div slot="header" slot-scope="scope" style="display: flex; flex-direction: column">
                        <div style="display: flex">
                            <template v-if="excell导入.选择列list[scope.column.property]">
                                <span style="color: red; line-height: 40px; padding-right: 5px" v-if="excell导入.选择列list[scope.column.property].必填"> * </span>
                                <el-input :value="excell导入.选择列list[scope.column.property].别名 || excell导入.选择列list[scope.column.property].列名" readonly>
                                    <template slot="append">
                                        <el-button
                                            @click="
                                                () => {
                                                    excell导入.选择列list[scope.column.property] = null;
                                                    计算未指定列名list();
                                                }
                                            "
                                            icon="el-icon-circle-close"
                                            style="padding: 12px"></el-button>
                                    </template>
                                </el-input>
                            </template>
                            <el-select v-else @change="计算未指定列名list()" placeholder="请指定列名" v-model="excell导入.选择列list[scope.column.property]" value-key="列名" style="width: 100%" clearable>
                                <el-option v-for="(item, index2) in excell导入.未指定列名list" :key="index2" :value="item">
                                    <span style="float: left; margin-right: 100px"><span style="color: red" v-if="item.必填">*</span> {{ item.别名 || item.列名 }}</span>

                                    <span style="color: blue; float: right" v-if="item.fun">可自动获取</span>
                                    <span style="color: blue; float: right" v-if="typeof item.默认值 != 'undefined'">默认值{{ item.默认值 }}</span>
                                    <span style="color: red; float: right" v-if="item.必选">必选</span>
                                    <span style="color: red; float: right" v-if="item.唯一">唯一</span>
                                </el-option>
                            </el-select>
                        </div>
                        <div style="color: red" v-if="(excell导入.选择列list[scope.column.property] || {}).唯一 && excell导入.data.GroupBy((a) => a[item]).Where((a) => a.count > 1).length > 0">唯一列有重复值</div>
                        <div style="color: red" v-if="(excell导入.选择列list[scope.column.property] || {}).必填 && excell导入.data.Where((a) => a[item] == '' || typeof a[item] == 'undefined').length > 0">必填列有空值</div>
                    </div>
                    <template slot-scope="scope">
                        <el-input v-if="(excell导入.当前行 || {}).__rowNum__ == scope.row.__rowNum__ && (excell导入.当前列 || {}).label == item" v-model="scope.row[item]"></el-input>
                        <div v-else :class="{ errordiv: (excell导入.选择列list[scope.column.property] || {}).唯一 && excell导入.data.Where((a) => a[item] == scope.row[item]).length > 1 }">
                            <div v-if="(excell导入.选择列list[scope.column.property] || {}).唯一 && excell导入.data.Where((a) => a[item] == scope.row[item]).length > 1">重复</div>
                            <div>{{ scope.row[item] }}</div>
                        </div>
                    </template>
                </u-table-column>
                <u-table-column label="编辑" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="warning" size="small" @click="excell导入.data.Remove(scope.row)">删除</el-button>
                    </template>
                </u-table-column>
            </u-table>
        </elModal>
    </div>
</template>

<script>
import mapState2 from "@/util/vuexExt.js";
import { mapActions } from "vuex";
import elModal from "@/components/elModal.vue";
export default {
    components: { elModal },
    computed: {
        ...mapState2(["版本号", "软件名称", "加载完成", "当前商户", "当前门店", "当前员工", "门店list", "分组门店list", "有权限门店list"]),
    },
    data() {
        return {
            isCollapse: false,
            menuList: [
                {
                    name: "首页",
                    icon: "el-icon-s-home",
                    to: "/main/index",
                },
                {
                    name: "微信支付宝收款",
                    icon: "el-icon-s-order",
                    children: [
                        { name: "收款明细", to: "/main/shoukuan/mx", visual: () => this.get权限("收款明细") },
                        { name: "商户日记录", to: "/main/shoukuan/shrjl", visual: () => this.get权限("商户日记录") && (this.当前门店 || {}).I_门店Id == 0 },
                        { name: "门店日记录", to: "/main/shoukuan/mdrjl", visual: () => this.get权限("门店日记录") },
                        { name: "收款汇总", to: "/main/shoukuan/hz", visual: () => this.get权限("收款汇总") },
                        { name: "银行卡到账记录", to: "/main/shoukuan/js", visual: () => this.get权限("银行卡到账记录") },
                    ],
                    visual: () => this.get权限("微信支付宝收款"),
                },

                {
                    name: "餐饮收银系统",
                    icon: "el-icon-s-order",
                    children: [
                        { name: "营业统计", to: "/main/canyin/yytj", visual: () => this.get权限("营业统计") },
                        { name: "商品统计", to: "/main/canyin/sptj", visual: () => this.get权限("商品统计") },
                        { name: "优惠统计", to: "/main/canyin/yhtj", visual: () => this.get权限("优惠统计") },
                        { name: "收款统计", to: "/main/canyin/sktj", visual: () => this.get权限("收款统计") },
                    ],
                    visual: () => this.get权限("餐饮收银系统"),
                },

                {
                    name: "会员",
                    icon: "el-icon-s-order",
                    children: [
                        { name: "会员概况", to: "/main/huiyuan/gk", visual: () => this.get权限("会员概况") },
                        { name: "会员列表", to: "/main/huiyuan/list", visual: () => this.get权限("会员列表") },
                        { name: "充值消费记录", to: "/main/huiyuan/czxfjl", visual: () => this.get权限("充值消费记录") },
                        { name: "交易汇总", to: "/main/huiyuan/jyhz", visual: () => this.get权限("交易汇总") },
                        // { name: '交易排行', to: '/main/huiyuan/jyph', visual: () => this.get权限('交易排行') },
                    ],
                    visual: () => this.get权限("会员"),
                },

                {
                    name: "优惠券",
                    icon: "el-icon-s-order",
                    children: [
                        { name: "优惠券查询", to: "/main/youhuiquan/search", visual: () => this.get权限("优惠券查询") },
                        { name: "优惠券设置", to: "/main/youhuiquan/setting", visual: () => this.get权限("优惠券设置") },
                    ],
                    visual: () => this.get权限("优惠券"),
                },

                {
                    name: "订货配送系统",
                    icon: "el-icon-s-order",
                    children: [
                        { name: "订货单", to: "/main/peisong/dhd", visual: () => this.get权限("订货单") },
                        { name: "订货明细", to: "/main/peisong/mx", visual: () => this.get权限("订货明细") },
                        { name: "订货统计", to: "/main/peisong/tj", visual: () => this.get权限("订货统计") },
                        { name: "门店订货单", to: "/main/peisong/mddhd", visual: () => this.get权限("门店订货单") },
                        { name: "门店订货明细", to: "/main/peisong/mdmx", visual: () => this.get权限("门店订货明细") },
                        { name: "门店订货统计", to: "/main/peisong/mdtj", visual: () => this.get权限("门店订货统计") },
                    ],
                    visual: () => this.get权限("订货配送系统"),
                },

                {
                    name: "进销存",
                    icon: "el-icon-s-order",
                    children: [
                        { name: "原料库存", to: "/main/jinxiaocun/kc", visual: () => this.get权限("原料库存") },
                        { name: "出入库明细", to: "/main/jinxiaocun/crkmx", class: "submenu", visual: () => this.get权限("出入库明细") },
                        { name: "出入库统计", to: "/main/jinxiaocun/crktj", class: "submenu", visual: () => this.get权限("出入库统计") },

                        { name: "入库单", to: "/main/jinxiaocun/rkd", visual: () => this.get权限("入库单") },
                        { name: "入库明细", to: "/main/jinxiaocun/rkmx", class: "submenu", visual: () => this.get权限("入库明细") },
                        { name: "入库统计", to: "/main/jinxiaocun/rktj", class: "submenu", visual: () => this.get权限("入库统计") },

                        { name: "出库单", to: "/main/jinxiaocun/ckd", visual: () => this.get权限("出库单") },
                        { name: "出库明细", to: "/main/jinxiaocun/ckmx", class: "submenu", visual: () => this.get权限("出库明细") },
                        { name: "出库统计", to: "/main/jinxiaocun/cktj", class: "submenu", visual: () => this.get权限("出库统计") },

                        { name: "调拨单", to: "/main/jinxiaocun/dbd", visual: () => this.get权限("调拨单") },
                        { name: "调拨明细", to: "/main/jinxiaocun/dbmx", class: "submenu", visual: () => this.get权限("调拨明细") },
                        { name: "调拨统计", to: "/main/jinxiaocun/dbtj", class: "submenu", visual: () => this.get权限("调拨统计") },

                        { name: "盘点单", to: "/main/jinxiaocun/pdd", visual: () => this.get权限("盘点单") },

                        // { name: '设置', to: '/main/jinxiaocun/setup', visual: () => this.get权限('设置') },
                    ],
                    visual: () => this.get权限("进销存"),
                },
                // {
                //     name: '配送系统', icon: 'el-icon-s-order', children: [], visual: () => this.get权限('营业单据'),
                // },
                // {
                //     name: '智慧门店小程序', icon: 'el-icon-s-order', children: [], visual: () => this.get权限('营业单据'),
                // },
                // {
                //     name: '会员系统', icon: 'el-icon-s-order', children: [], visual: () => this.get权限('营业单据'),
                // },

                {
                    name: "基本资料",
                    icon: "el-icon-s-tools",
                    children: [
                        { name: "原材料", to: "/main/setup/ycl", visual: () => this.get权限("原材料") },
                        { name: "配送线路", to: "/main/setup/psxl", visual: () => this.get权限("配送线路") },
                        { name: "打印模板", to: "/main/setup/dymb", visual: () => this.get权限("打印模板") },
                        // { name: '门店', to: '/main/setup/md', visual: () => this.get权限('设置') },
                        // { name: '员工', to: '/main/setup/yg', visual: () => this.get权限('员工') },
                        { name: "商品", to: "/main/setup/sp", visual: () => this.get权限("商品") },
                        // { name: '商品BOM', to: '/main/setup/bom', visual: () => this.get权限('商品BOM') },
                    ],
                    visual: () => this.get权限("基本资料"),
                },
            ],

            excell导入: {
                data: [],
                导入列名list: [],
                列名list: [],
                未指定列名list: [],
                选择列list: {},
                当前行: {},
                当前列: {},
            },

            选中门店: null,
        };
    },
    async mounted() {
        const 配送router = [
            {
                path: "/main/peisong/dhd",
                name: "peisong_dd",
                component: () => import(/* webpackChunkName: "peisong" */ "@/views/7配送中心/1订货单.vue"),
                meta: { title: "订货单", closable: true },
            },
            {
                path: "/main/peisong/mx",
                name: "peisong_dd",
                component: () => import(/* webpackChunkName: "peisong" */ "@/views/7配送中心/2订货明细.vue"),
                meta: { title: "订货明细", closable: true },
            },
            {
                path: "/main/peisong/tj",
                name: "peisong_dd",
                component: () => import(/* webpackChunkName: "peisong" */ "@/views/7配送中心/3订货统计.vue"),
                meta: { title: "订货统计", closable: true },
            },
            {
                path: "/main/peisong/mddhd",
                name: "peisong_dd",
                component: () => import(/* webpackChunkName: "peisong" */ "@/views/7配送中心/门店订货单.vue"),
                meta: { title: "门店订货单", closable: true },
            },
            {
                path: "/main/peisong/mdmx",
                name: "peisong_dd",
                component: () => import(/* webpackChunkName: "peisong" */ "@/views/7配送中心/门店订货明细.vue"),
                meta: { title: "门店订货明细", closable: true },
            },
            {
                path: "/main/peisong/mdtj",
                name: "peisong_dd",
                component: () => import(/* webpackChunkName: "peisong" */ "@/views/7配送中心/门店订货统计.vue"),
                meta: { title: "门店订货统计", closable: true },
            },
        ];
        try {
            if (!this.当前商户 || !this.当前员工) {
                await this.onInit();
            }
            this.加载完成 = true;
            window.显示excel数据并导入 = this.显示excel数据并导入;
            const type = this.当前门店.C_门店类型;
            const 门店list = ["订货单", "订货明细", "订货统计"];
            const 配送中心list = ["门店订货单", "门店订货明细", "门店订货统计"];
            if (type == "门店") {
                const routerList = 配送router.filter((a) => !门店list.includes(a.meta.title));
                routerList.forEach((e) => {
                    this.$router.matcher.addRoute("Main", e);
                });
            } else {
                const routerList = 配送router.filter((a) => !配送中心list.includes(a.meta.title));
                routerList.forEach((e) => {
                    this.$router.matcher.addRoute("Main", e);
                });
            }
        } catch (error) {
            await this.$Alert(error);
            //这里跳转到登录页,要用重新加载的方式,否则首页$wait会报错
            location.href = location.origin + location.pathname + location.search + "#/login";
        }
    },
    methods: {
        ...mapActions(["获取员工", "获取商品"]),
        async onInit() {
            let result = await this.$postAsync("/api/boss", {
                cmd: "获取当前登录",
            });
            this.当前员工 = result.data;
            this.当前商户 = result.商户;
            const list = result.门店list;
            if (list.length > 1) {
                list.unshift({
                    I_商户Id: this.当前商户.I_商户Id,
                    I_门店Id: 0,
                    C_门店名称: "总部",
                });
                this.当前门店 = list[0];
            } else {
                this.当前门店 = result.当前门店 || list.Where((a) => a.C_门店名称 != "总部")[0];
            }
            this.有权限门店list = list;

            this.分组门店list = result.分组门店list;
            this.门店list = result.门店list;
            let mdid = window.location.query("md");
            if (mdid) {
                let tmp门店 = this.有权限门店list.FirstOrDefault('$.I_门店Id=="' + mdid + '"');
                if (!tmp门店) tmp门店 = this.有权限门店list[0];
                window.location.query("md", tmp门店.I_门店Id);
                this.当前门店 = tmp门店;
            }
            console.log(this.当前门店);
            //this.选中门店 = this.门店list.FirstOrDefault('$.I_门店Id=="' + tmp门店.I_门店Id + '"');
        },
        get权限(e) {
            if (!this.当前门店) return;
            const 门店list = ["订货单", "订货明细", "订货统计"];
            const 配送中心list = ["门店订货单", "门店订货明细", "门店订货统计"];

            const type = this.当前门店.C_门店类型;
            if (type == "门店") {
                return !门店list.includes(e);
            } else {
                return !配送中心list.includes(e);
            }
        },
        handleCommand(command) {
            try {
                if (command == "logout") this.onLogout();
                if (command == "refresh") this.onRefresh();
                if (command == "favorite") {
                    if (!window.external.AddFavorite) throw "您的浏览器不支持此功能!";
                    window.external.AddFavorite("https://boss.yixinshuke.com", "壹新商户后台");
                }
                if (command == "shortcut") {
                    var content = `[{000214A0-0000-0000-C000-000000000046}] \n
Prop3=19,11  \n
[InternetShortcut]  \n
IDList= \n
URL=https://boss.yixinshuke.com \n
IconFile=https://boss.yixinshuke.com/favicon.ico \n
IconIndex=1 \n
`;
                    this.openDownloadDialog(new Blob([content]), "壹新商户后台.url");
                }
            } catch (error) {
                this.$Alert(error);
            }
        },
        async onLogout() {
            try {
                await this.$confirm("确定要退出吗?", "退出确认", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                });
                this.$postAsync("/api/boss", {
                    cmd: "退出登录",
                });
                window.store.commit("init");
                this.$router.push("/login");
            } catch (error) {
                this.$Alert(error);
            }
        },
        async onRefresh() {
            try {
                await this.$confirm("确认要强制刷新页面吗?", "强制刷新页面", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                });
                window.location.query("time", new Date().getTime());
            } catch (error) {
                this.$Alert(error);
            }
        },
        //excell导入
        计算未指定列名list() {
            let 已选择列名list = [];
            for (const key in this.excell导入.选择列list) {
                const tmp选择 = this.excell导入.选择列list[key];
                if (tmp选择) {
                    已选择列名list.push(tmp选择.列名);
                }
            }
            this.excell导入.未指定列名list = this.excell导入.列名list.Where((a) => !已选择列名list.includes(a.列名));
        },
        async 显示excel数据并导入(data = [], 列名list = [], 导入fun) {
            //await window.显示excel数据并导入([{a:1,b:2},{a:'',b:'3'}],[{列名:'编号',必选:false,必填:true,默认值:0},{列名:'名称',必选:true,必填:true}])
            if (data.length < 1) throw "导入数据为空!";
            let 导入列名list = 列名list.Select((a) => a.别名);
            let 选择列list = {};
            导入列名list.forEach((key) => {
                选择列list[key] = "";
            });
            this.excell导入 = {
                data,
                列名list,
                未指定列名list: [],
                导入列名list,
                选择列list,
            };
            //自动选择
            try {
                导入列名list.forEach((导入列名) => {
                    let tmp = this.excell导入.列名list.FirstOrDefault((a) => a.别名 == 导入列名 || a.列名.includes(导入列名));
                    if (tmp) this.excell导入.选择列list[导入列名] = tmp;
                });
            } catch (error) {
                console.log(error);
            }
            this.计算未指定列名list();
            await this.$refs.excell导入选择列名对话框.show({
                title: "请为导入excell数据指定列名",
                beforeClose: async () => {
                    try {
                        let 已选择列名list = [];
                        for (const key in this.excell导入.选择列list) {
                            const tmp选择 = this.excell导入.选择列list[key];
                            if (tmp选择) {
                                if (已选择列名list.includes(tmp选择.列名)) throw "列名(" + tmp选择.列名 + ")不能重复";

                                if (tmp选择.必填) {
                                    this.excell导入.data.forEach((row, index) => {
                                        let tmpdata = row[key] || (typeof tmp选择.默认值 == "undefined" ? "" : tmp选择.默认值);
                                        if (tmpdata === "") throw "第(" + (index + 1) + ")行(" + tmp选择.列名 + ")不能为空";
                                    });
                                }
                                已选择列名list.push(tmp选择.列名);
                            }
                        }
                        if (已选择列名list.length < 1) throw "请为需要的列指定列名!";

                        //必选列表
                        let 必选列名list = this.excell导入.列名list.Where("$.必选");
                        必选列名list.forEach((e) => {
                            if (!已选择列名list.includes(e.列名)) throw "列名(" + e.列名 + ")必须指定!";
                        });

                        let 返回data = [];
                        for (let index = 0; index < this.excell导入.data.length; index++) {
                            const row = this.excell导入.data[index];

                            let tmpobj = {};
                            for (const key in this.excell导入.选择列list) {
                                const tmp选择 = this.excell导入.选择列list[key];
                                if (tmp选择) {
                                    tmpobj[tmp选择.列名] = row[key] || (typeof tmp选择.默认值 == "undefined" ? "" : tmp选择.默认值);

                                    if (tmp选择.必填) {
                                        if (tmpobj[tmp选择.列名] === "") throw "第(" + (index + 1) + ")行(" + tmp选择.列名 + ")不能为空";
                                    }
                                    if (tmp选择.类型 == String) {
                                        tmpobj[tmp选择.列名] = tmpobj[tmp选择.列名].toString();
                                    }
                                    if (tmp选择.类型 == Boolean) {
                                        tmpobj[tmp选择.列名] = !!tmpobj[tmp选择.列名];
                                    }
                                    if (tmp选择.类型 == Number) {
                                        tmpobj[tmp选择.列名] = parseFloat(tmpobj[tmp选择.列名]);
                                    }
                                    if (tmp选择.类型 == Array) {
                                        if (tmp选择.分隔符) {
                                            tmpobj[tmp选择.列名] = JSON.tryParse(tmpobj[tmp选择.列名]) || tmpobj[tmp选择.列名].split(tmp选择.分隔符 || ",").Where("$");
                                        } else {
                                            tmpobj[tmp选择.列名] = JSON.tryParse(tmpobj[tmp选择.列名]);
                                        }
                                    }
                                    if (tmp选择.类型 == Object) {
                                        tmpobj[tmp选择.列名] = JSON.tryParse(tmpobj[tmp选择.列名]);
                                    }
                                }
                            }
                            //计算列
                            let 计算列list = 列名list.Where("$.fun");
                            for (let i = 0; i < 计算列list.length; i++) {
                                const tmp列 = 计算列list[i];
                                if (typeof tmpobj[tmp列.列名] == "undefined") {
                                    tmpobj[tmp列.列名] = await tmp列.fun(tmpobj, index, 返回data);

                                    if (tmp列.必填) {
                                        if (tmpobj[tmp列.列名] === "" || typeof tmpobj[tmp列.列名] == "undefined") throw "第(" + (index + 1) + ")行(" + tmp列.列名 + ")不能为空";
                                    }
                                }
                            }
                            返回data.push(tmpobj);
                        }
                        //检查唯一
                        let 唯一列list = 列名list.Where("$.唯一");
                        for (let index = 0; index < 唯一列list.length; index++) {
                            const 唯一列 = 唯一列list[index];
                            let 重复list = 返回data.GroupBy((a) => a[唯一列.列名]).Where((a) => a.count > 1);
                            if (重复list.length > 0) {
                                let 重复str = 重复list.Select((a) => a.key).join(",");
                                throw "列(" + 唯一列.列名 + ")有以下重复值<br>" + 重复str;
                            }
                        }

                        await 导入fun(返回data);

                        return true;
                    } catch (error) {
                        this.$Alert(error);
                    }
                },
            });
        },
        onCellClick(row, column, cell, event) {
            this.$set(this.excell导入, "当前行", row);
            this.$set(this.excell导入, "当前列", column);
        },
        onMDChange(value) {
            window.location.query("md", value.I_门店Id);
        },
    },
};
</script>

<style lang="scss">
.router-tab__container > .router-alive {
    overflow: hidden;
}

//菜单选中颜色
.el-menu-item.is-active {
    background-color: #409eff !important;
    color: #fff !important;
}

//tab页选中颜色
.router-tab__item.is-active {
    background-color: #409eff !important;
    color: #fff !important;
    border-color: #409eff !important;
}
.router-tab__item {
    border: none !important;
}
.router-tab__header {
    border-bottom: 2px solid #409eff !important;
}

.submenu {
    padding-left: 60px !important;
    line-height: 30px !important;
    height: 30px !important;
    background-color: #565758 !important;
}

.dark .el-input__inner {
    background-color: rgb(84, 92, 100);
    color: white;
    border: none;
    border-radius: 0;
    border-bottom: 1px solid gray;
}
</style>
